import { CommonEnums } from 'src/app/shared/common.enums';

export class DxFlow_Fwd_Lnk {
    dxFlow_Id: number;
    obj_Id: number;
    fwd_Lnk_Obj_Id: number;
    obj_Cd: string;
    fwd_Lnk_Obj_Cd: string;
    lnkCndVal: string;
    lnkCndValid_Cd: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.fwd_Lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fwd_Lnk_Obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.lnkCndVal = CommonEnums.defaults.STRING_EMPTY;
        this.lnkCndValid_Cd = CommonEnums.defaults.VALID_CD;
    }

    static parse(dxFlow_Fwd_LnkTmp: any): DxFlow_Fwd_Lnk {
        let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk = new DxFlow_Fwd_Lnk();
        dxFlow_Fwd_Lnk.copyFrom(dxFlow_Fwd_LnkTmp as DxFlow_Fwd_Lnk);
        return dxFlow_Fwd_Lnk;
    }

    getPrimaryKey(): string {
        return this.dxFlow_Id + '.' + this.obj_Id + '.' + this.fwd_Lnk_Obj_Id;
    }

    copy(): DxFlow_Fwd_Lnk {
        let dxFlow_Fwd_LnkTmp: DxFlow_Fwd_Lnk = new DxFlow_Fwd_Lnk();

        dxFlow_Fwd_LnkTmp.dxFlow_Id = this.dxFlow_Id;
        dxFlow_Fwd_LnkTmp.obj_Id = this.obj_Id;
        dxFlow_Fwd_LnkTmp.fwd_Lnk_Obj_Id = this.fwd_Lnk_Obj_Id;
        dxFlow_Fwd_LnkTmp.obj_Cd = this.obj_Cd;
        dxFlow_Fwd_LnkTmp.fwd_Lnk_Obj_Cd = this.fwd_Lnk_Obj_Cd;
        dxFlow_Fwd_LnkTmp.lnkCndVal = this.lnkCndVal;
        dxFlow_Fwd_LnkTmp.lnkCndValid_Cd = this.lnkCndValid_Cd;

        return dxFlow_Fwd_LnkTmp;
    }

    copyFrom(dxFlow_Fwd_LnkTmp: DxFlow_Fwd_Lnk): void {
        this.dxFlow_Id = dxFlow_Fwd_LnkTmp.dxFlow_Id;
        this.obj_Id = dxFlow_Fwd_LnkTmp.obj_Id;
        this.fwd_Lnk_Obj_Id = dxFlow_Fwd_LnkTmp.fwd_Lnk_Obj_Id;
        this.obj_Cd = dxFlow_Fwd_LnkTmp.obj_Cd;
        this.fwd_Lnk_Obj_Cd = dxFlow_Fwd_LnkTmp.fwd_Lnk_Obj_Cd;
        this.lnkCndVal = dxFlow_Fwd_LnkTmp.lnkCndVal;
        this.lnkCndValid_Cd = dxFlow_Fwd_LnkTmp.lnkCndValid_Cd;
    }

    compare(dxFlow_Fwd_LnkTmp: DxFlow_Fwd_Lnk): string {
        let dxFlow_Fwd_LnkString: string = this.toString(false);
        let dxFlow_Fwd_LnkTmpString: string = dxFlow_Fwd_LnkTmp.toString(false);

        if (dxFlow_Fwd_LnkString != dxFlow_Fwd_LnkTmpString) {
            return dxFlow_Fwd_LnkString + ',' + dxFlow_Fwd_LnkTmpString;
        }
        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DxFlow_Fwd_Lnk [ dxFlow_Id =" + this.dxFlow_Id +
            ", obj_Id =" + this.obj_Id +
            ", fwd_Lnk_Obj_Id = " + this.fwd_Lnk_Obj_Id +
            ", obj_Cd=" + this.obj_Cd +
            ", fwd_Lnk_Obj_Cd=" + this.fwd_Lnk_Obj_Cd +
            ", lnkCndVal=" + this.lnkCndVal +
            ", lnkCndValid_Cd=" + this.lnkCndValid_Cd;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}
